import React from "react";
import styled from "styled-components";
import SpiralDeco from "../../../assets/spiraldeco.svg";

const OurServicesListItem = styled.div`
  background-color: rgba(29, 109, 193, 1);
  border-radius: 10px;
  height: 100%;
  padding: 24px;
  background-image: url(${SpiralDeco});
  background-repeat: no-repeat;
  background-position: top right;
  background-size: 120px;
`;
const OurServicesListItemImageWrapper = styled.figure`
  width: 40px;
  height: 40px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
`;
const OurServicesListItemImage = styled.img``;
const OurServicesListItemHeading = styled.p`
  font-weight: 700;
  color: rgba(255, 252, 252, 1);
  font-size: 25px;
  padding-top: 12px;
  padding-bottom: 16px;
  @media (max-width: 480px) {
    font-size: 16px;
  }
`;
const OurServicesListItemPara = styled.p`
  font-weight: 400;
  font-size: 16px;
  color: rgba(255, 252, 252, 1);
  line-height: 24px;
  @media (max-width: 480px) {
    font-size: 12px;
  }
`;
const OurServicesListItemWrapper = styled.div`
  max-width: calc(100% / 3);
  max-height: calc(100% / 2);
  min-height: 280px;
  padding: 12px;

    @media (max-width: 1025px) {
    max-width: calc(100%/2);
    max-height: calc(100%);
    padding-left: 18px;
    padding-right: 18px;
  }

  @media (max-width: 480px) {
    max-width: calc(100%);
    max-height: calc(100%);
    min-height: 100px;
  };
`;
export const OurServicesListItems = ({ heading, para, img }) => {
  return (
    <OurServicesListItemWrapper>
      <OurServicesListItem>
        <OurServicesListItemImageWrapper>
          <OurServicesListItemImage src={img} alt="" />
        </OurServicesListItemImageWrapper>
        <OurServicesListItemHeading>{heading}</OurServicesListItemHeading>
        <OurServicesListItemPara>{para}</OurServicesListItemPara>
      </OurServicesListItem>
    </OurServicesListItemWrapper>
  );
};
